import countries from './countriesSAP';

/**
 * @name getAllowedShipToCountries
 * @desc Determine which countries an account can ship/save addresses to, based on the account's
 * sold-to/SAP country. Sales org determines which distribution center (DC) serves an account, and
 * some DCs (e.g. the EMEA DC, sales org 2000) serve multiple countries out of one location: any
 * country sharing a sales org code with the account's sold-to country may be shipped to, with no
 * further region-based restriction (e.g. no Europe vs. Africa/Middle East distinction).
 * Countries with no `salesOrgCode` tag keep the original behavior: restricted to just that one
 * sold-to country.
 * @param {String} accountCountryCode the code2 of the account's sold-to/SAP country
 * @returns {Array} the countriesSAP entries the account may ship/save addresses to
 */
const getAllowedShipToCountries = accountCountryCode => {
  const accountCountry = countries.find(country => country.code2 === accountCountryCode);
  if (!accountCountry) return [];

  if (!accountCountry.salesOrgCode) return [accountCountry];

  return countries.filter(country => country.salesOrgCode === accountCountry.salesOrgCode);
};

export default getAllowedShipToCountries;
